import { render, staticRenderFns } from "./ContractPlaceholdersModal.vue?vue&type=template&id=40559a13&scoped=true"
import script from "./ContractPlaceholdersModal.vue?vue&type=script&lang=js"
export * from "./ContractPlaceholdersModal.vue?vue&type=script&lang=js"
import style0 from "./ContractPlaceholdersModal.vue?vue&type=style&index=0&id=40559a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40559a13",
  null
  
)

export default component.exports